/**
 * WCAG 4.1.2 — when Flickity/MFRCarousel marks a cell aria-hidden="true",
 * remove its focusable descendants from the tab order.
 */
(function () {
  if (window._mfrA11yCarouselFocus) return;
  window._mfrA11yCarouselFocus = true;

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function syncCell(cell) {
    if (!(cell instanceof Element)) return;
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    cell.querySelectorAll(FOCUSABLE).forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-a11y-prev-tabindex')) {
          el.setAttribute(
            'data-a11y-prev-tabindex',
            el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : ''
          );
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-a11y-prev-tabindex')) {
        var prev = el.getAttribute('data-a11y-prev-tabindex');
        if (prev === '') el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', prev);
        el.removeAttribute('data-a11y-prev-tabindex');
      }
    });
  }

  function syncAll(root) {
    (root || document)
      .querySelectorAll(
        '.mfr-carousel__item[aria-hidden], .product-carousel__item[aria-hidden], .flickity-slider > [aria-hidden]'
      )
      .forEach(syncCell);
  }

  function bindFlickity(el) {
    if (!el || el._a11yFocusBound || typeof Flickity === 'undefined') return;
    var flkty = Flickity.data(el);
    if (!flkty) return;
    el._a11yFocusBound = true;
    var run = function () {
      syncAll(el);
    };
    flkty.on('ready', run);
    flkty.on('change', run);
    flkty.on('settle', run);
    run();
  }

  function scan() {
    document.querySelectorAll('.flickity-enabled').forEach(bindFlickity);
    syncAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(function (mutations) {
    var needsScan = false;
    mutations.forEach(function (mutation) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'aria-hidden'
      ) {
        syncCell(mutation.target);
      }
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        needsScan = true;
      }
      if (mutation.addedNodes && mutation.addedNodes.length) needsScan = true;
    });
    if (needsScan) scan();
  });

  observer.observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['aria-hidden', 'class'],
  });
})();
